import { defineComponent } from 'vue-demi';
import { openBlock, createElementBlock, renderSlot, createTextVNode, toDisplayString } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var script = defineComponent({
  name: 'OrError',
  props: {
    error: {
      type: String,
      default: ''
    }
  }
});

const _hoisted_1 = {
  class: "or-error"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("p", _hoisted_1, [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.error), 1 /* TEXT */)])]);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-ee64af38 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-ee64af38 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-error[data-v-ee64af38] {\n  font-size: var(--fs-0);\n  line-height: var(--lh-0);\n  color: var(--c-error);\n  word-break: break-word;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-ee64af38";
script.__file = "src/components/or-error/OrError.vue";

export { script as s };
